import { configureStore, ThunkAction, Action, combineReducers, getDefaultMiddleware } from '@reduxjs/toolkit';

import userReducer from '../Store/Auth';
import roadmapReducer from '../Store/Roadmap';
import projectReducer from '../Store/Project';
import settingsReducer from '../Store/Settings';
//import analyticsReducer from '../Store/Analytics';
import utilityReducer from '../Store/Utility';
import folderReducer from '../Store/Folder';
import chatReducer from '../Store/Chat';
import stripeReducer from '../Store/Stripe';
import dashReducer from '../Store/Dash';

const combinedReducer = combineReducers({
  user: userReducer,
  roadmap: roadmapReducer,
  project: projectReducer,
  settings: settingsReducer,
  //analytics: analyticsReducer,
  utility: utilityReducer,
  folder: folderReducer,
  chat: chatReducer,
  stripe: stripeReducer,
  dash: dashReducer,
});

const rootReducer = (state: any, action: any) => {
  //console.log(action.type);
  if (action.type === 'api/auth/logout/fulfilled') {
    //state = {};
    const { stripe } = state; /* preserver Stripe, specifically pricing plans */
    state = { stripe };
  }
  return combinedReducer(state, action)
}
/* middleware is so I don't get non-serializable errors in console. I store the websocket in
   redux store which works fine. Also, I try not to store dates in state from backend, but
   when I do it works fine, socket is fine too. I could move socket to react context, but
   for now I want to keep in redux store.
*/
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
    }),
});

/*
export const store = configureStore({
  reducer: {
    user: userReducer,
    project: projectReducer,
    settings: settingsReducer,
  },
});
*/
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
